<template>
  <v-container :class="{ 'no-padding': noPadding }">
    <v-layout row justify-end>
      <slot name="actions"></slot>
      <v-flex xs4>
        <v-text-field v-model="search" :label="'app.pages.products.nutrient' | trans"></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs3 d-flex>
        <v-data-iterator
            :items="[firstColumn]"
            :rows-per-page-items="[10000]"
            hide-actions
            content-tag="v-layout"
            row
            wrap
            justify-center
            fill-height
        >
          <template v-slot:item="props">
            <v-flex xs12>
              <v-card height="100%">
                <v-toolbar color="primary" dark>
                  <v-toolbar-title>{{ 'app.menu.basic' | trans }}</v-toolbar-title>
                </v-toolbar>
                <v-list dense>
                  <v-list-tile v-for="item in props.item" :key="item.id">
                    <v-list-tile-content :class="{ w60: true }">{{ item.name }}:</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      {{ getNutrientValue(item) }}
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>
          </template>
        </v-data-iterator>
      </v-flex>
      <v-flex xs3 d-flex class="pl-1">
        <v-data-iterator
            :items="[secondColumn]"
            :rows-per-page-items="[10000]"
            hide-actions
            content-tag="v-layout"
            row
            wrap
            justify-center
            fill-height
        >
          <template v-slot:item="props">
            <v-flex xs12>
              <v-card height="100%">
                <v-toolbar color="primary" dark>
                  <v-toolbar-title>{{ 'app.minerals' | trans }}</v-toolbar-title>
                </v-toolbar>
                <v-list dense>
                  <v-list-tile v-for="item in props.item" :key="item.id">
                    <v-list-tile-content class="w60">{{ item.name }}:</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      {{ getNutrientValue(item) }}
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>
          </template>
        </v-data-iterator>
      </v-flex>
      <v-flex xs3 d-flex class="pl-1">
        <v-data-iterator
            :items="[thirdColumn]"
            :rows-per-page-items="[10000]"
            hide-actions
            content-tag="v-layout"
            row
            wrap
            justify-center
            fill-height
        >
          <template v-slot:item="props">
            <v-flex xs12>
              <v-card height="100%">
                <v-toolbar color="primary" dark>
                  <v-toolbar-title>{{ 'app.vitamins' | trans }}</v-toolbar-title>
                </v-toolbar>
                <v-list dense>
                  <v-list-tile v-for="item in props.item" :key="item.id">
                    <v-list-tile-content :class="{ w60: true }">{{ item.name }}:</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      {{ getNutrientValue(item) }}
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>
          </template>
        </v-data-iterator>
      </v-flex>
      <v-flex xs3 d-flex class="pl-1">
        <v-data-iterator
            :items="[fourthColumn]"
            :rows-per-page-items="[10000]"
            hide-actions
            content-tag="v-layout"
            row
            wrap
            justify-center
            fill-height
        >
          <template v-slot:item="props">
            <v-flex xs12>
              <v-card height="100%">
                <v-toolbar color="primary" dark>
                  <v-toolbar-title>{{ 'app.amino_acids' | trans }}</v-toolbar-title>
                </v-toolbar>
                <v-list dense>
                  <v-list-tile v-for="item in props.item" :key="item.id">
                    <v-list-tile-content class="w60">{{ item.name }}:</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      {{ getNutrientValue(item) }}
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>
          </template>
        </v-data-iterator>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import {helpers} from "../helpers";
import {trans} from "../app";
import {CARBO, FATS, FIBER, GLICEMIC_INDEX, GLICEMIC_LOAD, PROTEIN, WBT, WW} from "../services/NutrientDetailsProvider";
import {glCalculation, wbtCalculation } from "../utils/additionalNutrientCalculators";

export default {
  props: {
    noPadding: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      search: null,
      columns: {
        firstColumn: [],
        secondColumn: [],
        thirdColumn: [],
        fourthColumn: []
      },
      initialData: {
        firstColumn: [],
        secondColumn: [],
        thirdColumn: [],
        fourthColumn: [],
      },
      initialized: false,
    }
  },
  computed: {
    firstColumn: function () {
      if (!!this.search) {
        return this.columns.firstColumn.filter(this.filterElements);
      }

      return this.columns.firstColumn;
    },
    secondColumn: function () {
      if (!!this.search) {
        return this.columns.secondColumn.filter(this.filterElements);
      }

      return this.columns.secondColumn;
    },
    thirdColumn: function () {
      if (!!this.search) {
        return this.columns.thirdColumn.filter(this.filterElements);
      }

      return this.columns.thirdColumn;
    },
    fourthColumn: function () {
      if (!!this.search) {
        return this.columns.fourthColumn.filter(this.filterElements);
      }

      return this.columns.fourthColumn;
    },
  },
  methods: {
    init(data) {
      const nutrientMapper = (nutrient) => ({
        name: nutrient.name,
        id: nutrient.id,
        unit: nutrient.unit,
        short_name: nutrient.short_name,
        value: '',
      });
      this.columns.firstColumn = data[1].map(nutrientMapper);
      this.columns.secondColumn = data[2].map(nutrientMapper);
      this.columns.thirdColumn = data[3].map(nutrientMapper);
      this.columns.fourthColumn = data[4].map(nutrientMapper);

      this.initialData.firstColumn = helpers.deepClone(this.columns.firstColumn);
      this.initialData.secondColumn = helpers.deepClone(this.columns.secondColumn);
      this.initialData.thirdColumn = helpers.deepClone(this.columns.thirdColumn);
      this.initialData.fourthColumn = helpers.deepClone(this.columns.fourthColumn);
      this.initialized = true;
    },
    load(nutrients) {
      const findNutrientAndSetValue = (nutrient) => {
        const nutrientWithValue = nutrients.find((nutrientWithValue) => nutrientWithValue.id === nutrient.id);
        if (nutrientWithValue !== undefined) {
          nutrient.value = nutrientWithValue.value;
        }
      };
      this.columns.firstColumn.forEach(findNutrientAndSetValue);
      this.columns.secondColumn.forEach(findNutrientAndSetValue);
      this.columns.thirdColumn.forEach(findNutrientAndSetValue);
      this.columns.fourthColumn.forEach(findNutrientAndSetValue);

      const carbo = nutrients.find((nutrient) => nutrient.id === CARBO);
      const carboValue = carbo !== undefined ? carbo.value : 0;
      const fiber = nutrients.find((nutrient) => nutrient.id === FIBER);
      const fiberValue = fiber !== undefined ? fiber.value : 0;
      const protein = nutrients.find((nutrient) => nutrient.id === PROTEIN);
      const proteinValue = protein !== undefined ? protein.value : 0;
      const fats = nutrients.find((nutrient) => nutrient.id === FATS);
      const fatsValue = fats !== undefined ? fats.value : 0;
      const gi = nutrients.find((nutrient) => nutrient.id === GLICEMIC_INDEX);
      const giValue = gi !== undefined ? gi.value : 0;
      const ww = nutrients.find((nutrient) => nutrient.id === WW);
      const wwValue = ww !== undefined ? ww.value : 0;

      this.columns.firstColumn.push(
          {
            name: trans('app.products.create_modal.lg'),
            id: GLICEMIC_LOAD,
            value: glCalculation(carboValue, fiberValue, giValue),
          },
          {
            name: trans('app.products.create_modal.ww'),
            id: WW,
            value: wwValue
          },
          {
            name: trans('app.products.create_modal.wbt'),
            id: WBT,
            value: wbtCalculation(proteinValue, fatsValue),
          }
      );
    },
    unload() {
      this.columns.firstColumn = helpers.deepClone(this.initialData.firstColumn);
      this.columns.secondColumn = helpers.deepClone(this.initialData.secondColumn);
      this.columns.thirdColumn = helpers.deepClone(this.initialData.thirdColumn);
      this.columns.fourthColumn = helpers.deepClone(this.initialData.fourthColumn);
    },
    getNutrientValue(nutrient) {
      return nutrient.value ? `${nutrient.value} ${nutrient.unit || ''}` : '-';
    },
    filterElements(el) {
      return el.name.toLowerCase().includes(this.search.toLowerCase());
    },
    isInitialized() {
      return this.initialized;
    }
  }
}
</script>
<style scoped>
.w60 {
  width: 60%;
}

>>> .v-list__tile__content.align-end {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  word-break: break-word;
}

>>> .v-list__tile__content.align-end {
  text-align: right;
}

>>> .v-list__tile:not(.v-list__tile--avatar) {
  height: initial;
  padding-top: 2px;
  padding-bottom: 2px;
}

>>> .v-list__tile:hover {
  background: #eee;
}

.v-dialog__content {
  z-index: 1030 !important;
}
.no-padding {
  padding: 0 !important;
}
</style>
